import React from 'react';

const SvgArrowFullLeft = (props) => (
  <svg width={16} height={11} {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      strokeWidth={0.812}
      d="M14.986 5.312l-12.38.002 3.584-3.57-.677-.675L.774 5.79l4.738 4.72.677-.674-3.582-3.57 12.385-.001z"
    />
  </svg>
);

export default SvgArrowFullLeft;
